// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1PLhA","entry":"Modal_entry__3huyo","exit":"Modal_exit__q0tfs","btn":"Modal_btn__CwEd2"};